import { render, staticRenderFns } from "./OrderedListSmallFont.vue?vue&type=template&id=04547283&scoped=true&"
import script from "./OrderedListSmallFont.vue?vue&type=script&lang=ts&"
export * from "./OrderedListSmallFont.vue?vue&type=script&lang=ts&"
import style0 from "./OrderedListSmallFont.vue?vue&type=style&index=0&id=04547283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04547283",
  null
  
)

export default component.exports